module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0013.jpg?v=f40f3ce5";